var _defs, _g, _g2, _path, _rect, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiptMeldrPowered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 281,
    height: 138,
    viewBox: "0 0 281 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    width: 205,
    height: 34,
    transform: "translate(0 -0.133)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1686",
    "data-name": "Group 1686",
    transform: "translate(-235 -140)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150",
    transform: "translate(66.33 68.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(258.471 109.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M695.737,349.7a17.013,17.013,0,0,0-7.533-1.4,25.346,25.346,0,0,0-4.774.455,21.19,21.19,0,0,0-4.578,1.429q-.793.35-1.577.784a9.476,9.476,0,0,0-1.929-1.271,17.017,17.017,0,0,0-7.534-1.4,33.17,33.17,0,0,0-3.6.2,31.1,31.1,0,0,0-3.507.584,26.335,26.335,0,0,0-3.377,1.006,33.026,33.026,0,0,0-3.215,1.4v29.809h4.676V353.823a33.046,33.046,0,0,1,4.351-.974,27.8,27.8,0,0,1,4.156-.325,12.149,12.149,0,0,1,4.676.747,5.9,5.9,0,0,1,2.6,1.948,7.041,7.041,0,0,1,1.137,2.5,11.268,11.268,0,0,1,.292,2.468v21.107h4.676V360.188a15.855,15.855,0,0,0-.865-5.454,15.062,15.062,0,0,1,3.722-1.625,15.771,15.771,0,0,1,4.156-.585,12.15,12.15,0,0,1,4.676.747,5.891,5.891,0,0,1,2.6,1.948,7.034,7.034,0,0,1,1.137,2.5,11.256,11.256,0,0,1,.292,2.468v21.107h4.676V360.188a14.868,14.868,0,0,0-1.267-6.429A8.592,8.592,0,0,0,695.737,349.7Z",
    transform: "translate(-654.108 -335.184)",
    fill: "#001276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M982.4,356.941a12.822,12.822,0,0,0-4.514-6.3,13.67,13.67,0,0,0-8.344-2.338q-6.625,0-10.424,4.189t-3.8,12.567a22.214,22.214,0,0,0,1.818,9.547,12.584,12.584,0,0,0,5.2,5.747,15.927,15.927,0,0,0,7.988,1.916,30.646,30.646,0,0,0,6.2-.584A22.894,22.894,0,0,0,981.688,380V375.19a19.2,19.2,0,0,1-2.987,1.429,20.02,20.02,0,0,1-3.7,1.006,25.3,25.3,0,0,1-4.416.357,9.87,9.87,0,0,1-7.761-3.085q-2.762-3.084-2.76-8.995H983.7A26.4,26.4,0,0,0,982.4,356.941Zm-21.3.877a7.144,7.144,0,0,1,3.15-4.059,10.815,10.815,0,0,1,5.293-1.169q4.61,0,6.851,2.4,2.088,2.24,2.4,6.624H960.282A17.152,17.152,0,0,1,961.1,357.817Z",
    transform: "translate(-899.6 -335.184)",
    fill: "#001276"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 4.676,
    height: 44.746,
    transform: "translate(92.869 1.364)",
    fill: "#001276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M1252.309,292.448c-.459-.175-.956-.347-1.494-.514a38.332,38.332,0,0,0-3.831-.974,17.583,17.583,0,0,0-3.377-.39q-7.469,0-11.138,4.384t-3.669,11.917a23.663,23.663,0,0,0,1.461,9.06,12.71,12.71,0,0,0,8.67,7.858,19.457,19.457,0,0,0,4.936.682,27.747,27.747,0,0,0,4.286-.357,22.285,22.285,0,0,0,4.287-1.1,8.97,8.97,0,0,0,3.28-2.013,4.2,4.2,0,0,0,1.266-3.085V277.387h-4.676Zm0,25.009q0,1.169-2.5,1.948a19.827,19.827,0,0,1-5.878.779q-4.222,0-6.429-1.883a9.319,9.319,0,0,1-2.988-4.9,26.094,26.094,0,0,1-.779-6.527,17.853,17.853,0,0,1,1.007-6.267,8.727,8.727,0,0,1,3.182-4.221,9.7,9.7,0,0,1,5.682-1.526,18.881,18.881,0,0,1,4.384.552,15.984,15.984,0,0,1,4.319,1.721Z",
    transform: "translate(-1122.486 -277.387)",
    fill: "#001276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M1471.621,335.8l-11.77-17.961a11.472,11.472,0,0,0,3.911-1.457,11.731,11.731,0,0,0,4.351-4.611,13.986,13.986,0,0,0,1.559-6.689q0-6.235-3.214-9.417t-9.579-3.182h-17.794V335.8h4.675v-17.47H1454.8l11.3,17.47Zm-27.861-38.9h12.6q5,0,6.819,2.305a9.751,9.751,0,0,1,1.818,6.2,8.048,8.048,0,0,1-2.435,6.332q-2.436,2.177-7.826,2.176h-10.976Z",
    transform: "translate(-1293.871 -289.691)",
    fill: "#001276"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659",
    transform: "translate(168.669 71.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M239.064,213.779c-3.569-2.922-8.507-4.346-15.127-4.346-7.748,0-13.555,2.275-17.235,6.768-2.977,3.625-4.475,8.654-4.475,14.942,0,5.159,1.535,9.061,4.531,11.632,2.534,2.164,6.029,3.255,10.356,3.255a14.932,14.932,0,0,0,14.9-14.9,3.033,3.033,0,0,0-6.066,0,8.871,8.871,0,0,1-8.858,8.858c-6.214,0-8.858-2.644-8.858-8.858,0-4.845,1.054-8.581,3.107-11.1,2.478-3.033,6.694-4.549,12.556-4.549,5.159,0,8.858.98,11.3,2.977,2.94,2.4,4.364,6.565,4.364,12.686,0,10.855-1.331,16.81-4.568,20.6-2.349,2.718-7.212,6.343-22.357,6.343-8.229,0-14.332-2.127-18.622-6.472-8.821-8.95-8.58-26.167-8.377-40,.037-2.053.055-3.994.055-5.862a26.682,26.682,0,0,1,1.424-8.636l20.859,6.861a3.634,3.634,0,0,0,4.771-3.44v-.758a3.626,3.626,0,0,1,4.771-3.44l22.8,7.508a3.619,3.619,0,0,0,4.716-4.031A32.8,32.8,0,0,0,212.767,172.8h-.111a33.021,33.021,0,0,0-32.991,32.99c0,1.831-.037,3.736-.056,5.77-.222,14.96-.481,33.582,10.115,44.326,5.418,5.492,13.13,8.285,22.931,8.285,13.61,0,21.932-2.607,26.943-8.451,3.144-3.643,6.029-9.154,6.029-24.539C245.647,223.21,243.428,217.367,239.064,213.779Z",
    transform: "translate(-179.545 -164.171)",
    fill: "#00e676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M469.238,153c-2.386-14.239-16.736-25.427-34.655-26.851a3.614,3.614,0,0,0-3.884,3.625v23.781a3.63,3.63,0,0,0,3.625,3.625h31.326A3.613,3.613,0,0,0,469.238,153Zm-16.9-4.549a5.011,5.011,0,1,1,5.011-5.011A5.015,5.015,0,0,1,452.336,148.452Z",
    transform: "translate(-384.255 -126.139)",
    fill: "#1426ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M430.7,187.6v16.051a3.63,3.63,0,0,0,3.625,3.625H448.6A32.915,32.915,0,0,0,430.7,187.6Z",
    transform: "translate(-384.255 -176.234)",
    fill: "#001276"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1675",
    "data-name": "Group 1675",
    transform: "translate(311 244.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1674",
    "data-name": "Group 1674",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1671",
    "data-name": "Group 1671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1670",
    "data-name": "Group 1670",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1669",
    "data-name": "Group 1669",
    opacity: 0.08,
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1668",
    "data-name": "Group 1668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1667",
    "data-name": "Group 1667",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M8.467,0H196.851a8.467,8.467,0,0,1,8.467,8.467V25.4a8.467,8.467,0,0,1-8.467,8.467H8.467A8.467,8.467,0,0,1,0,25.4V8.467A8.467,8.467,0,0,1,8.467,0",
    fill: "#0c0f18"
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M121.376,12.515l-3.236,6.35-.784,1.53h1.8l2.223-4.35L123.6,20.4h1.8Z",
    transform: "translate(6.846 0.73)",
    fill: "#140f35"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 1.605,
    height: 7.886,
    transform: "translate(159.887 13.241)",
    fill: "#140f35"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1673",
    "data-name": "Group 1673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1672",
    "data-name": "Group 1672",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M98.97,12.526l-3.931-.011V20.4H98.98a3.856,3.856,0,0,0,2.773-1.164c.078-.078.157-.157.224-.236a3.931,3.931,0,0,0-3.008-6.473m2.3,3.941a2.3,2.3,0,0,1-2.3,2.3h-2.3v-4.6h2.3a2.3,2.3,0,0,1,2.3,2.3",
    transform: "translate(5.545 0.73)",
    fill: "#140f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M133.2,16.2c-.015-.019-.032-.037-.049-.055a2.542,2.542,0,0,0-1.873-.828h-2.736a.562.562,0,0,1-.554-.554v-.046a.562.562,0,0,1,.554-.554h4.633V12.515h-4.633a2.19,2.19,0,0,0-2.182,2.193v.043a2.153,2.153,0,0,0,.38,1.237,2.092,2.092,0,0,0,.282.351,2.17,2.17,0,0,0,1.521.615h2.738a.9.9,0,0,1,0,1.8h-4.676V20.4h4.676a2.54,2.54,0,0,0,1.957-4.161.217.217,0,0,1-.037-.039",
    transform: "translate(7.372 0.73)",
    fill: "#140f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M103.261,18.868l-.784,1.53h1.8l2.223-4.35,2.223,4.35h1.8L106.5,12.515Z",
    transform: "translate(5.978 0.73)",
    fill: "#140f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M138.121,12.511a3.942,3.942,0,1,0,.005,0h-.005m2.3,3.95a2.3,2.3,0,1,1-2.3-2.3h0a2.3,2.3,0,0,1,2.3,2.3",
    transform: "translate(7.828 0.73)",
    fill: "#140f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M162.707,14.106h3.05v6.306h1.605V14.106h3.05V12.5h-7.706Z",
    transform: "translate(9.492 0.729)",
    fill: "#140f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M113.125,20.4h1.605V14.121h3.049V12.515h-7.7v1.606h3.05Z",
    transform: "translate(6.422 0.73)",
    fill: "#140f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M154.351,16.461a3.961,3.961,0,0,0,3.961,3.955h3.47V18.764h-3.476a2.328,2.328,0,0,1-2.156-1.482h4.457v-1.65h-4.457a2.32,2.32,0,0,1,2.155-1.482h3.47V12.5h-3.469a3.962,3.962,0,0,0-3.956,3.961",
    transform: "translate(9.005 0.729)",
    fill: "#140f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M146.688,14.154h3.09V12.511h-3.09a3.944,3.944,0,1,0-.129,7.888c.043,0,.086,0,.129,0h3.09V18.757h-3.09a2.3,2.3,0,0,1,0-4.6",
    transform: "translate(8.324 0.73)",
    fill: "#140f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M175.027,15.091l-2-2.591h-2.056l3.094,4.007.151.187v3.717h1.623V16.672L179.07,12.5h-2.045Z",
    transform: "translate(9.975 0.729)",
    fill: "#140f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M180.705,12.5a1.274,1.274,0,1,1-1.274,1.274,1.274,1.274,0,0,1,1.274-1.274",
    transform: "translate(10.468 0.729)",
    fill: "#e72418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M180.705,17.567a1.274,1.274,0,1,1-1.274,1.274,1.274,1.274,0,0,1,1.274-1.274",
    transform: "translate(10.468 1.025)",
    fill: "#e72418"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M13.49,20.415V12.88h3.27a2.8,2.8,0,0,1,1.9.586,2.021,2.021,0,0,1,.672,1.6,2.009,2.009,0,0,1-.683,1.6,2.789,2.789,0,0,1-1.889.592H14.855v3.155Zm1.365-4.2H16.6a1.653,1.653,0,0,0,1.074-.3,1.175,1.175,0,0,0,.005-1.677,1.661,1.661,0,0,0-1.08-.292H14.855Z",
    transform: "translate(0.787 0.751)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M24.477,20.506a3.729,3.729,0,0,1-1.905-.467,3.1,3.1,0,0,1-1.238-1.334,4.53,4.53,0,0,1-.434-2.052,4.518,4.518,0,0,1,.434-2.058,3.107,3.107,0,0,1,1.238-1.328,4.134,4.134,0,0,1,3.821,0A3.114,3.114,0,0,1,27.631,14.6a4.5,4.5,0,0,1,.434,2.046,4.53,4.53,0,0,1-.439,2.065,3.148,3.148,0,0,1-1.238,1.334,3.725,3.725,0,0,1-1.91.467m0-1.082a2,2,0,0,0,1.63-.713,3.171,3.171,0,0,0,.593-2.07,3.12,3.12,0,0,0-.593-2.056,2.227,2.227,0,0,0-3.249,0,3.115,3.115,0,0,0-.593,2.056,3.165,3.165,0,0,0,.593,2.07,1.99,1.99,0,0,0,1.619.713",
    transform: "translate(1.219 0.747)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M31.937,20.415,29.27,12.88h1.386l2.064,6.191h-.381L34.5,12.88l.974.011,2.1,6.181h-.36l2.106-6.191h1.3l-2.656,7.535H36.848l-2.021-5.779h.254l-2.043,5.779Z",
    transform: "translate(1.708 0.751)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M42.01,20.415V12.88h5.038v1.069h-3.7v2.1h3.493v1.08H43.343v2.223h3.7v1.069Z",
    transform: "translate(2.451 0.751)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M48.96,20.415V12.88h3.228a2.955,2.955,0,0,1,1.947.561A1.984,1.984,0,0,1,54.8,15.05a1.974,1.974,0,0,1-.688,1.582,2.857,2.857,0,0,1-1.916.587l.847-.169a1.128,1.128,0,0,1,.7.233,1.533,1.533,0,0,1,.487.72l.931,2.413H53.723l-.953-2.508a.867.867,0,0,0-.418-.5,1.576,1.576,0,0,0-.672-.127H50.3v3.133Zm1.334-4.191H52a1.83,1.83,0,0,0,1.143-.287,1.024,1.024,0,0,0,.36-.856,1.01,1.01,0,0,0-.36-.857A1.894,1.894,0,0,0,52,13.949h-1.7Z",
    transform: "translate(2.856 0.751)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M56.98,20.415V12.88h5.038v1.069h-3.7v2.1h3.493v1.08H58.313v2.223h3.7v1.069Z",
    transform: "translate(3.324 0.751)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M63.93,20.415V12.88H66.7a4.564,4.564,0,0,1,2.106.445,3.078,3.078,0,0,1,1.328,1.285,4.171,4.171,0,0,1,.46,2.027,4.222,4.222,0,0,1-.46,2.044A3.065,3.065,0,0,1,68.8,19.971a4.585,4.585,0,0,1-2.1.445ZM65.3,19.3h1.323a2.613,2.613,0,0,0,1.953-.667,2.76,2.76,0,0,0,.651-2,2.32,2.32,0,0,0-2.6-2.646H65.3Z",
    transform: "translate(3.73 0.751)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M76.279,20.415V12.88h3.313a2.912,2.912,0,0,1,1.826.519,1.889,1.889,0,0,1,.323,2.539,1.82,1.82,0,0,1-.984.636v-.085a1.923,1.923,0,0,1,1.127.646,1.881,1.881,0,0,1,.4,1.227A1.824,1.824,0,0,1,81.6,19.87a2.991,2.991,0,0,1-1.91.545Zm1.334-4.36h1.746a1.785,1.785,0,0,0,1.079-.265A.931.931,0,0,0,80.788,15a.916.916,0,0,0-.349-.794,1.837,1.837,0,0,0-1.079-.255H77.613Zm0,3.291h1.937a1.836,1.836,0,0,0,1.1-.259.985.985,0,0,0,.344-.841,1.011,1.011,0,0,0-.349-.847,1.75,1.75,0,0,0-1.09-.276H77.613Z",
    transform: "translate(4.45 0.751)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M85.958,20.415V17.029l.286.826L82.9,12.88h1.556l2.381,3.7h-.392l2.381-3.7h1.556l-3.334,4.974.275-.826v3.387Z",
    transform: "translate(4.836 0.751)",
    fill: "#040504"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptMeldrPowered);
export default __webpack_public_path__ + "static/media/receipt-meldr-powered.39154b737a4bdcd0e7c730a670aab31b.svg";
export { ForwardRef as ReactComponent };